<template>
  <div class="p-8 container m-auto">
    <app-nav :showNav="false" />
    <div class="w-full lg:w-1/2 pt-4 px-4 m-auto">
      <add-record-form  @complete="close" :text="url" />
    </div>
  </div>
</template>

<script>
 import AppNav from '@/components/AppNav';
 import AddRecordForm from '@/components/AddRecordForm';

 export default {
   data () {
     return {
       url: '',
     }
   },

   components: {AppNav, AddRecordForm},

   async created () {
     this.url = this.$route.query && this.$route.query.url ? this.$route.query.url : '';
   },

   methods: {
     async close () {
       // here close the window
       window.close();
     }
   }
 }
</script>
